import { Injectable } from '@angular/core';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { PromotionalType, PromotionalTypeGroup } from 'app/modules/main/models/publisher-tags-and-promotional-types';

@Injectable({ providedIn: 'root' })
export class PromotionalTypeSelectorMapper {

  public toPromotionalTypes(
    selectablePromotionalTypes: SelectableData<PromotionalType>[]
  ): PromotionalType[] {

    return selectablePromotionalTypes
      .map(selectablePromotionalType => selectablePromotionalType.data);
  }

  public toSelectablePromotionalTypes(
    promotionalTypeGroups: PromotionalTypeGroup[],
    selectedPromotionalTypes: PromotionalType[]
  ): SelectableData<PromotionalType>[] {

    const selectedPromotionalTypeIds =
      new Set(
        selectedPromotionalTypes
          .map(selectedPromotionalType => selectedPromotionalType.id)
      );

    return promotionalTypeGroups
      .filter(promotionalTypeGroup => !!promotionalTypeGroup.types.length)
      .flatMap(promotionalTypeGroup => {

        return promotionalTypeGroup.types
          .map(promotionalType => {
            return {
              data: promotionalType,
              id: String(promotionalType.id),
              label: promotionalType.name,
              selected: selectedPromotionalTypeIds.has(promotionalType.id),
              significantTerms: (
                (promotionalTypeGroup.name || '') + ' ' +
                (promotionalType.name || '')
              )
                .replace(/\s+/, ' ')
                .trim(),
            };
          });
      });
  }

}
